import { IDataGridColumn } from '../../../../common/interfaces/IDataGridColumn';

export const RxRulesColumns: IDataGridColumn[] = [
  {
    name: 'ruleId',
    labelCopy: 'rule #',
    sortable: false,
    interactive: false,
    flexBasis: '15%',
  },
  {
    name: 'name',
    labelCopy: 'name',
    sortable: false,
    interactive: false,
    flexBasis: '70%',
  },
  {
    name: 'modifier',
    labelCopy: 'modifier',
    sortable: false,
    interactive: false,
    flexBasis: '15%',
  },
];
